{
  "name": "ng-web-app",
  "version": "2.14.1",
  "scripts": {
    "ng": "ng",
    "ngcc": "ngcc",
    "start": "ng serve",
    "start-ssl": "ng serve --ssl --ssl-key cert/localhost.key  --ssl-cert cert/localhost.crt",
    "start:prod": "ng serve --configuration production",
    "start:staging": "ng serve --configuration=staging",
    "build": "npm run copy-pdf-worker && ng build",
    "build:prod": "npm run copy-pdf-worker && ng build --configuration production",
    "build:staging": "npm run copy-pdf-worker && ng build --configuration=staging",
    "build:stats": "npm run copy-pdf-worker && ng build --configuration production --stats-json",
    "test": "ng test",
    "test:headless": "ng test --no-watch --browsers=ChromeHeadless",
    "test:headless:watch": "ng test --browsers=ChromeHeadless",
    "test:coverage": "ng test --no-watch --code-coverage --browsers=ChromeHeadless",
    "lint": "ng lint",
    "e2e": "npx playwright test",
    "e2e:chrome": "npx playwright test --project chromium",
    "e2e:debug": "npx playwright test --debug",
    "e2e:chrome:debug": "npx playwright test --debug --project chromium",
    "e2e:database:backup": "npx tsx tests/database/database-backup.ts",
    "e2e:database:testing": "npx tsx tests/database/load-testing-data.ts",
    "e2e:database:restore": "npx tsx tests/database/database-restore.ts",
    "e2e:with-data-swap": "npm run e2e:database:backup && npm run e2e:database:testing && npm run e2e && npm run e2e:database:restore",
    "bundle-report": "npm run build:stats && webpack-bundle-analyzer dist/ng-web-app/stats.json",
    "copy-pdf-worker": "cp node_modules/pdfjs-dist/build/pdf.worker.min.mjs src/assets/lib/",
    "version": "echo $npm_package_name-$npm_package_version",
    "clean": "rm -rf node_modules package-lock.json .angular && npm i"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.1.2",
    "@angular/cdk": "^18.1.2",
    "@angular/common": "^18.1.2",
    "@angular/compiler": "^18.1.2",
    "@angular/core": "^18.1.2",
    "@angular/forms": "^18.1.2",
    "@angular/material": "^18.1.2",
    "@angular/material-date-fns-adapter": "^18.1.2",
    "@angular/platform-browser": "^18.1.2",
    "@angular/platform-browser-dynamic": "^18.1.2",
    "@angular/router": "^18.1.2",
    "@ngbracket/ngx-layout": "^18.0.0",
    "@ngxs/devtools-plugin": "^18.0.0",
    "@ngxs/form-plugin": "^18.0.0",
    "@ngxs/storage-plugin": "^18.0.0",
    "@ngxs/store": "^18.0.0",
    "date-fns": "^3.3.1",
    "pdfjs-dist": "^4.3.136",
    "rxjs": "^7.8.1",
    "tslib": "^2.0.0",
    "zone.js": "^0.14.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.1.2",
    "@angular/cli": "^18.1.2",
    "@angular/compiler-cli": "^18.1.2",
    "@angular/language-service": "^18.1.2",
    "@playwright/test": "^1.35.1",
    "@types/jasmine": "^5.1.2",
    "@types/jasminewd2": "^2.0.8",
    "@types/node": "^22.1.0",
    "angular-eslint": "^18.2.0",
    "dotenv": "^16.0.3",
    "eslint": "^9.8.0",
    "jasmine-core": "^5.1.1",
    "jasmine-spec-reporter": "^7.0.0",
    "karma": "^6.4.0",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.0.3",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.0.0",
    "ts-node": "^10.9.2",
    "typescript": "~5.5.4",
    "typescript-eslint": "^8.0.0",
    "webpack-bundle-analyzer": "^4.6.1"
  }
}